export default __webpack_public_path__ + "3b89dd103490708d19a95adcae52210e.ttf";